import { SET_LANDING_PAGE_URLS, SET_SUPPORT_INFO } from 'constants/actionTypes';

export const initialState = {
  landingPageUrls: {},
  referrerCountryCode: null,
  supportEmail: '',
  supportPhoneNumber: ''
};

/**
 * Support Info reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function supportInfoReducer(state = initialState, action) {
  switch (action.type) {

    case SET_SUPPORT_INFO:
      return {
        ...state,
        supportEmail: action.supportEmail,
        supportPhoneNumber: action.supportPhoneNumber,
        referrerCountryCode: action.referrerCountryCode
      };

    case SET_LANDING_PAGE_URLS:
      return {
        ...state,
        landingPageUrls: action.landingPageUrls
      };

    default:
      return state;
  }
}
